import React, { useEffect } from 'react';
import { useMachine } from '@xstate/react';
import { createMachine } from 'xstate';

import { actions } from './actions';
import { MACHINE_CONFIG } from './config';
import { services } from './services';

export const createDeathEventPageContext = React.createContext({});
export let createDeathEventPageMachine: any;

export const useSMCreateDeathEventPage = (_context: any) => {
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  createDeathEventPageMachine = createMachine(_machineConfig, {
    services,
    actions,
  });
  const [state, send] = useMachine(createDeathEventPageMachine);

  useEffect(() => {
    send({ type: 'START' });
  }, []);

  return {
    createDeathEventPageMachine,
    createDeathEventPageState: state,
    createDeathEventPageSend: send,
  };
};
